import { app } from '../../bootstrap/core';
import { switchNotAllowedState } from './switchNotAllowed.state';
import { switchNotAllowedComponent } from './switchNotAllowed.component';

app.config(switchNotAllowedState);
app.component(switchNotAllowedComponent.name, switchNotAllowedComponent);



// WEBPACK FOOTER //
// ./src/app/components/switchNotAllowed/switchNotAllowed.js